import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ServiceAccessDisabledComponent } from './service-access-disabled.component';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot([
      { path: '', component: ServiceAccessDisabledComponent },
    ])
  ],
  declarations: [ServiceAccessDisabledComponent]
})
export class ServiceAccessDisabledModule {
  ngDoBootstrap(appRef: ApplicationRef) {
    appRef.bootstrap(ServiceAccessDisabledComponent);
  }
}
